






















import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Mutations, Actions } from '@/ts/store/Constants';
import TicketHelper from '@/mixins/TicketHelper.vue';

@Component
export default class RemainWatcher extends Mixins(TicketHelper) {
     @Prop() public ticket: any;
     @Prop() public assignee?: any;

    constructor() {
        super();
    }

    public changeTicketAssignee(remain: boolean) {
        const data = {
            assigneeId: this.assignee.id,
            ticketId: this.ticket.id,
            remain,
        };

        this.$store.dispatch(Actions.CHANGE_TICKET_ASSIGNEE, data);
    }

    public closeRemianWatcher() {
        this.$store.commit(Mutations.TICKET_REMAIN_WATCHER_VISIBILITY, false);
    }
}
